import type { FaireProductEntity } from "../../entity_types/product";

export const p_3d2wq4u97s: FaireProductEntity = {
  token: "p_3d2wq4u97s",
  type: "product",
  name: "Strawberry Nectar - Emile Vergeois - Glass Bottle",
  brandToken: "b_puxke2dnj7",
  brandName: "Apricot & Honey Gourmet",
  imageUrl:
    "https://cdn.faire.com/fastly/2f0b4f39c83d7b5f1df024732ad022a4050d77d18147945cafdf6f2565cd3b80.jpeg",
  galleryImageUrls: [],
  priceDollars: 6.85,
  description:
    "Experience the delightful taste of Strawberry Nectar from Apricot & Honey Gourmet. As an importer and distributor of French artisanal fine food, we take pride in bringing you this exquisite beverage. Our Strawberry Nectar is an embodiment of our commitment to quality, capturing the pure essence of strawberries in a glass bottle. Enjoy the sweet and refreshing taste, reminiscent of a summer day in France. It's more than just a fruit juice, it's a gourmet experience.",
  tags: [],
  msrpDollars: 13.69,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:48:33.721Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
